export const PICTURE_IN_PICTURE_ENTER_ICON_DIMENSIONS = {
  small: {
    width: '0.875rem',
    height: '0.75rem',
  },
  large: {
    width: '1.25rem',
    height: '1.125rem',
  },
};

export const PICTURE_IN_PICTURE_LEAVE_ICON_DIMENSIONS = {
  small: {
    width: '0.875rem',
    height: '0.875rem',
  },
  large: {
    width: '1.125rem',
    height: '1.125rem',
  },
};
